export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

// store phone numbers saved in place of the customer phone when the customer left it blank
// (national part only, so +41 44 508 79 00, 0041445087900 and 044 508 79 00 all match)
const STORE_PHONE_NUMBERS = ['8938037900', '445087900', '720815440']

export function isStorePhoneNumber(phone) {
  if (!phone) return false
  const digits = String(phone).replace(/\D/g, '')
  return STORE_PHONE_NUMBERS.some(
    (number) => digits.endsWith(number) && digits.length - number.length <= 4
  )
}
